<!-- =========================================================================================
  File Name: game.vue
  Description: Report Game
========================================================================================== -->

<template>
  <div id="report-game">

    <vx-card title="游戏报表">
      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <flat-pickr v-model="startTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <flat-pickr v-model="endTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          <template slot="append">
            <vs-input class="w-32" v-model="uid" placeholder="UID / 用户名" />
          </template>
          <template slot="append">
            <vs-select class="w-48" v-model="platVal">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in platList" />
            </vs-select>
          </template>
          <template slot="append">
            <vs-select class="w-48" v-model="gameVal">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in gameList" />
            </vs-select>
          </template>
          <template slot="append">
            <vs-select class="w-32" v-model="range">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in rangeList" />
            </vs-select>
          </template>
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vx-card>
            <vs-table stripe :data="list" noDataText="暂无报表记录" class=" w-full">
              <template slot="thead">
                <vs-th width="150">日期</vs-th>
                <vs-th>注单数</vs-th>
                <vs-th>下注金额 (元)</vs-th>
                <vs-th>盈亏 (元)</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="index" v-for="(item, index) in list">
                  <vs-td :data="index">{{item.date}}</vs-td>
                  <vs-td :data="item.count" :class="{ 'font-bold': item.count > 0 }">{{item.count}}</vs-td>
                  <vs-td :data="item.total" :class="{ 'font-bold': item.total > 0 }">{{item.total}}</vs-td>
                  <vs-td :data="item.bonus" :class="{ 'font-bold': item.bonus > 0 }">{{item.bonus}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="font-bold">合计</vs-td>
                  <vs-td :class="{ 'font-bold': total[0] > 0 }">{{total[0].toFixed(4)}}</vs-td>
                  <vs-td :class="{ 'font-bold': total[1] > 0 }">{{total[1].toFixed(4)}}</vs-td>
                  <vs-td :class="{ 'font-bold': total[2] > 0 }">{{total[2].toFixed(4)}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
        <div class="vx-col sm:w-1/2">
          <vx-card>
            <vue-apex-charts v-if="chartData.loaded" height=400 :options="chartData.chartOptions" :series="chartData.series" />
          </vx-card>
        </div>
      </div>


    </vx-card>

  </div>
</template>

<script>

import VueApexCharts from 'vue-apexcharts'
import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'

export default {
  data() {
    return {
      list: [],
      startTime: '',
      endTime: '',
      gameList: [],
      platList: [],
      gameVal: 0,
      platVal: 0,
      rangeList: { '': '范围', self: '自身', direct: '直属', team: '团队' },
      range: '',
      uid: '',
      total: [0, 0, 0],
      flatPickrConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        locale: flatPickrZh
      },
      chartData: {
        loaded: false,
        series: [{
          name: '注单数',
          data: []
        },{
          name: '投注额',
          data: []
        },{
          name: '盈亏',
          data: []
        }],
        chartOptions: {
          chart: {
            type: 'line',
            toolbar: {
              show: false
            }
          },
          title: {
            text: '游戏折线图',
            align: 'left'
          },
          xaxis: {
            categories: []
          }
        }
      }
    }
  },
  components: {
    VueApexCharts
  },
  methods: {
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.start = this.startTime
      postdata.end = this.endTime
      postdata.uid = this.uid
      postdata.game = this.gameVal
      postdata.plat = this.platVal === 0 ? '' : this.platList[this.platVal]
      postdata.range = this.range
      this.chartData.loaded = false
      this.$utils.post('report-game', postdata).then(res => {
        this.list = res
        this.chartData.series[0].data = []
        this.chartData.series[1].data = []
        this.chartData.series[2].data = []
        this.total = [0, 0, 0]
        this.chartData.chartOptions.xaxis.categories = []
        for (const i in res) {
          this.chartData.series[0].data.unshift(res[i].count)
          this.chartData.series[1].data.unshift(res[i].total)
          this.chartData.series[2].data.unshift(res[i].bonus)
          this.chartData.chartOptions.xaxis.categories.unshift(i)
          this.total[0] += parseFloat(res[i].count)
          this.total[1] += parseFloat(res[i].total)
          this.total[2] += parseFloat(res[i].bonus)
        }
        this.chartData.loaded = true
      })
    },
    search() {
      this.load()
    }
  },
  mounted () {
    // 初始化时间
    const myDate = new Date()
    this.endTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)
    myDate.setTime(myDate.getTime() - 86400000 * 30)
    this.startTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)

    // 获取所有平台和游戏
    this.$utils.post('game-typeList', { authKey: localStorage.getItem('authKey') }).then(data => {
      this.gameList = ['全部游戏']
      for(let i in data) {
        if (!data[i]) continue
        this.gameList.push(data[i].name)
        for(let k in data[i].list) {
          if (this.platList.indexOf(data[i].list[k]) == -1) {
            this.platList.push(data[i].list[k])
          }
          this.platList.sort()
          this.platList.unshift('全部平台')
        }
      }
    })

    this.load()
  }
}
</script>
